export const CREATIVE_MAX_BYTES = 5 * 1024 * 1024;
export const CREATIVE_TYPES = ["image/jpeg", "image/png", "image/gif"];
export const CREATIVE_HINT = "JPEG, PNG, or GIF. Up to 5 MB.";

const EXTENSIONS = [".jpg", ".jpeg", ".png", ".gif"];

export const validateCreativeFile = (file) => {
    if (!file) {
        return { ok: false, message: "Choose an image file first." };
    }
    const type = (file.type || "").toLowerCase();
    const name = (file.name || "").toLowerCase();
    const hasAllowedType = CREATIVE_TYPES.includes(type);
    const hasAllowedExt = EXTENSIONS.some((ext) => name.endsWith(ext));
    if (!hasAllowedType && !hasAllowedExt) {
        return { ok: false, message: "Use a JPEG, PNG, or GIF." };
    }
    if (file.size > CREATIVE_MAX_BYTES) {
        return { ok: false, message: "Image must be 5 MB or smaller." };
    }
    return { ok: true };
};
